import { DataGridPro, gridClasses, useGridApiRef } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { SvbrgSearchPurchaseOrderInput, SvbrgSearchPurchaseOrderOutput } from '@/generated/gql/graphql';
import { I18nNamespace } from '@/legacy/common/types';
import { usePurchaseOrderResultDataGrid } from '~/routes/IntakeChat/components/PurchaseOrderItemSearchResult/PurchaseOrderResult.dataGrid';

import { DevelopmentTool, ToolResultComponent } from '.';

export const PurchaseOrderTool: ToolResultComponent<
  DevelopmentTool.searchPurchaseOrder,
  SvbrgSearchPurchaseOrderInput,
  SvbrgSearchPurchaseOrderOutput
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  const config = usePurchaseOrderResultDataGrid();
  const apiRef = useGridApiRef();

  const callMessage = t('callNoQuery');
  const resultMessage = t('resultNoQuery');

  switch (tool.state) {
    case 'input-available':
    case 'input-streaming':
      return <ChatLoadingIndicator message={callMessage} />;

    case 'output-available': {
      const orders = tool.output.orders ?? [];

      // Zero-result case: render a non-interactive indicator. Mirrors PurchaseOrderItemTool —
      // the agent's preamble already describes the absence in text when orders.length === 0.
      if (orders.length === 0) {
        return <ChatToolResultIndicator message={resultMessage} defaultOpen={false} disabled={true} />;
      }

      return (
        <ChatToolResultIndicator message={resultMessage} defaultOpen={false} disabled={false}>
          <DataGridPro
            {...config}
            sx={{
              [`&.${gridClasses.root}`]: {
                '--DataGrid-containerBackground': 'transparent',
              },
            }}
            apiRef={apiRef}
            disableColumnMenu
            rows={orders}
            getRowId={(row) => row.id}
          />
        </ChatToolResultIndicator>
      );
    }
  }
};
